import { GALLERY } from "../data/content";
import { Reveal, SectionHeading } from "./Reveal";

export const Gallery = () => {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-24 lg:py-32 scroll-mt-20"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20">
        <SectionHeading
          eyebrow="The Devata Inventory · Visual Archive"
          title={
            <>
              Nearly 2,000 faces,
              <br />
              carved in sandstone
            </>
          }
        />
        <Reveal delay={0.1}>
          <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4">
            {GALLERY.map((g, i) => (
              <div
                key={i}
                className={`group relative overflow-hidden rounded-sm deckle ${
                  i === 0 ? "col-span-2 row-span-2 aspect-square md:aspect-auto" : "aspect-[3/4]"
                }`}
              >
                <img
                  src={g.src}
                  alt={g.caption}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[var(--ink)]/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-400" />
                <span className="absolute bottom-3 left-3 right-3 font-mono text-[10px] uppercase tracking-[0.15em] text-[#F9F6F0] opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-400">
                  {g.caption}
                </span>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
